import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const klaviyoPartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('klaviyo:profile:unsubscribe:clicked', (payload) =>
    ampli.partnerIntegrationsKlaviyoProfileUnsubscribeClicked(payload),
  );

  partnerEvents.on('klaviyo:profile:unsubscribe:failed', (payload) =>
    ampli.partnerIntegrationsKlaviyoProfileUnsubscribeFailed(payload),
  );

  partnerEvents.on('klaviyo:profile:unsubscribe:succeeded', (payload) =>
    ampli.partnerIntegrationsKlaviyoProfileUnsubscribeSucceeded(payload),
  );

  partnerEvents.on('klaviyo:profile:subscribe:clicked', (payload) =>
    ampli.partnerIntegrationsKlaviyoProfileSubscriptionToChannelClicked(
      payload,
    ),
  );

  partnerEvents.on('klaviyo:profile:subscribe:failed', (payload) =>
    ampli.partnerIntegrationsKlaviyoProfileSubscriptionToChannelFailed(payload),
  );

  partnerEvents.on('klaviyo:profile:subscribe:succeeded', (payload) =>
    ampli.partnerIntegrationsKlaviyoProfileSubscriptionToChannelSucceeded(
      payload,
    ),
  );

  partnerEvents.on('klaviyo:profile:received', (payload) =>
    ampli.partnerIntegrationsKlaviyoProfileReceived(payload),
  );

  partnerEvents.on('klaviyo:messages:received', (payload) =>
    ampli.partnerIntegrationsKlaviyoMessagesReceived(payload),
  );

  partnerEvents.on('klaviyo:profile:failed', (payload) =>
    ampli.partnerIntegrationsKlaviyoProfileFailed(payload),
  );
};
